module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_ShouShou.0084.png.15f7fdaa.jpg";